import taskRequest from "@/api/task-request";
import { useTaskStore } from "@/store/task";

function idFrom(data: unknown): number | undefined {
  if (typeof data === "number") return data;
  return (data as { id?: number } | undefined)?.id;
}

/**
 * Find-or-create the patient's incomplete case history and set it in the task store.
 * Returns the id (0 on failure). Mirrors the creation side effect that lives in the
 * Demographics step, so the resume flow can re-establish it before skipping Demographics
 * (the portal-config history pages hard-require a valid case history id).
 */
export async function ensureCaseHistoryId(
  facilityKey: string,
  patientKey: string
): Promise<number> {
  if (!facilityKey || !patientKey) return 0;
  try {
    const findRes = await taskRequest.request.findIncompleteCaseHistory(facilityKey, patientKey);
    const foundId = idFrom(findRes?.data);
    if (foundId != null && foundId > 0) {
      useTaskStore.getState().setCurrentCaseHistoryId(foundId);
      return foundId;
    }
    const insertRes = await taskRequest.request.insertCaseHistory(facilityKey, patientKey, {
      aa: "false",
    });
    const newId = idFrom(insertRes?.data);
    if (newId != null && newId > 0) {
      useTaskStore.getState().setCurrentCaseHistoryId(newId);
      return newId;
    }
  } catch (e) {
    console.error("ensureCaseHistoryId failed:", e);
  }
  return 0;
}
